<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="popupTitle" width="750px" @close="close">
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="title-h4">IP 목록</div>
        <w-header-search-button @click="showHeaderSearchTool = !showHeaderSearchTool"></w-header-search-button>
      </el-row>
      <el-table-wrapper ref="ipTable" :height="600" :data="ipList" :columns="tableColumns" :column-default="columnDefault" remote :pagination="false"
        :show-search-tool="showHeaderSearchTool" :show-custom-header="true" @condition-change="loadData"></el-table-wrapper>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import trafficAPI from '@/api/settings/netdevice/traffic-settings';

export default {
  name: 'WIpListSlidingPopup',
  props: {
    popupParams: Object,
  },
  data() {
    return {
      popupVisible: false,
      showHeaderSearchTool: false,
      columnDefault,
      ipList: [],
      tableColumns: [
        { prop: 'netIpaddress', label: 'IP주소', width: 200, searchable: true, remoteProp: 'tigs.net_ipaddress' },
        { prop: 'hostName', label: '호스트명', searchable: true, formatter: this.getEmptyText },
      ],
    };
  },
  computed: {
    popupTitle() {
      if (this.popupParams) return `[${this.popupParams.ipGroupName}] IP 목록`;
      return '';
    },
  },
  methods: {
    open() {
      this.popupVisible = true;
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    close() {
      this.popupVisible = false;
      this.$refs.slidingPopup.visible = false;
      this.showHeaderSearchTool = false;
      // this.$refs.ipTable.resetFilter();
    },
    /**
     * IP 목록 조회
     * @author jeee12
     */
    loadData() {
      this.$nextTick(() => {
        const tableParams = this.$refs.ipTable.getParameter();
        const params = {
          ipGroupId: this.popupParams.ipGroupId,
          ...tableParams,
        };

        trafficAPI.getIpGroupIpList(params).then((response) => {
          if (response.data.success) {
            this.ipList = response.data.data;
          }
        });
      });
    },
    /**
     * 테이블 데이터 빈 값 체크
     * @author jeee12
     */
    getEmptyText(row, column, value) {
      if (!isNil(value) && value !== '') {
        return value;
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/TrafficSettings/IpGroupSettings/popup/IpListSlidingPopup.vue